import Toolbar from "toolbar/Toolbar";
import ToolbarItemLink from "toolbar/ToolbarItemLink";

if (window.User !== null) {
    Toolbar.addDefaultItem(new ToolbarItemLink("Website Users", "/admin/websiteUsers", "website-users", window.ADMIN_MODULE === "websiteUsers"), 2, Toolbar.RIGHT);
}
